
const taxRates = process.env.REACT_APP_STAGING !== 'no' ? ['txr_1KMgO1Fha9hdCHBgKKmiczEn'] : ['txr_1Ij37xFha9hdCHBg2hIWe4vC']

/**
 * Errors object to override defulat error messages
 */
const ErrorsObj = {
  // firebase login
  'email_missing': 'Email ID is required',
  'auth/email-already-in-use': 'email-already-in-use',
  'auth/account-exists-with-different-credential': `Lösenordet är ogiltigt eller så har användaren inget lösenord`,
  'auth/weak-password': 'Lösenordet ska vara minst 6 tecken',
  'auth/wrong-password': 'Lösenordet är ogiltigt eller så har användaren inget lösenord',
  'auth/user-not-found': 'Det finns ingen användarpost som motsvarar denna identifierare. Användaren kan ha tagits bort',
  'auth/popup-closed-by-user': 'Popup-fönstret har stängts av användaren innan operationen slutfördes',
  // firebase cloud
  'promotion_code_missing': 'Promotion code is required',
  'promo_id_missing': 'Promotion code id is required',
  'price_id_missing': 'Price ID is missing',
  'success_url_missing': 'Success Url param is missing',
  'customer_missing': 'Customer id is required',
  'subscription_id_missing': 'Subscription id required',
  'priceid_same_lastone': 'Selected plan is the same as currently running',
  // stripe
  'stripe_resource_missing': 'No such promotion code',
  'stripe_parameter_unknown': 'Received unknown parameter',
  'stripe_invoice_upcoming_none': 'No upcoming invoices',
  'stripe_cannot_reedemed': 'This coupon cannot be redeemed because it does not apply to anything in this order',
}


// Remove attribute 'readonly' on field click
const removeReadonlyAttr = (event) => {
  event.target.removeAttribute('readonly')
}


// temporary variable to display test products for these users
const allowEmails = [
  'prakhar@dk.se',
  'prakhar1@dk.se',
  'prakhar2@dk.se',
  'ahmad@dk.se',
  'ahmad2@dk.se',
  'ahmad3@dk.se',
  'ahm2ad@dk.se',
  'ahm3ad@dk.se',
]

export { taxRates, ErrorsObj, removeReadonlyAttr, allowEmails }
